import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import LoadRowsComponent from '../../../helpers/LoadRowsComponent';
import { excelStyles } from '../../../components/Grid/ExcelStyles/excelStyles';
import { getLocations } from '../../../api/locations';
// import StudyLinkForeignKey from '../../../components/Grid/CellRenderer/StudyLinkForeignKey';
// import OverrideField from '../../../helpers/OverrideField';
import OverrideField from '../../../helpers/OverrideField';
// import TotalRow from '../../components/Grid/CellRenderer/TotalRow';
import TotalRow from '../../../components/Grid/CellRenderer/TotalRow';
const LocationsGridReadOnly = ({
    locationsList,
    search,
    onRowClicked,
    onDeleteClicked,
    setRefresh,
    refresh,
    sort = "",
    setSort = () => {},
    isStudyDetail = false,
}) => {
  // console.log(locationsList)
  // const [rowData, setRowData] = useState(locationsList);
  const [gridApi, setGridApi] = useState(null);
  const [totalRows, setTotalRows] = useState(locationsList ? locationsList.length : 0);

  useEffect(() => {
    if(locationsList){
      setTotalRows(locationsList.length)
    }
  }, [locationsList]);

  useEffect(() => {
    if(refresh){
      let refreshOptions = {}
      // if adding the first row, purge for item to properly refresh
      if (gridApi.getDisplayedRowCount() === 0) refreshOptions = { purge: true };
      gridApi.refreshServerSideStore(refreshOptions);
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if(gridApi){
      //loads in more rows while scrolling
      const dataSource = {
        getRows: function(params) {
          // console.log(params.request);
          let sortParam = "";
          if(params.request.sortModel.length !== 0){
            const sortColumn = params.request.sortModel[0].colId;
            const sortWay = params.request.sortModel[0].sort;
            if(sortWay=== "desc"){
              sortParam += "-";
            }
            sortParam += sortColumn;
            sortParam = sortParam.replaceAll(".", "__");
          }
          if(sortParam){
            setSort(sortParam);
          }
          else{
            setSort("");
          }
          const rows = getLocations({limit: 100, offset: params.request.startRow, search: search, sort: sort})
          .then( res => {
            setTotalRows(res.count);
            params.success({
              rowData: res.results,
              rowCount: res.count
            })
            if(res.count === 0){
              gridApi.showNoRowsOverlay();
            }
            });
        }
        
      };
      gridApi.setServerSideDatasource(dataSource);
    }
  }, [gridApi, search, sort]);
  
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // const cellClicked = (event) => {
  //   const { cellRenderer } = event.colDef;
  //   if (cellRenderer !== "removeRow") {
  //     onRowClicked(event.data);
  //   }
  // };

  // const deleteRow = (itemId) => {
  //   onDeleteClicked(itemId);
  // };

  const onFilterChanged = () => {
    if (gridApi) {
      const displayedRowCount = gridApi.getDisplayedRowCount();
      setTotalRows(displayedRowCount);
    }
  };

  const gridOptions = {
    columnDefs: [
      {
        headerName: 'Recruitment Status',
        field: 'recruitment_status',
        cellRenderer: 'overrideField',
        cellRendererParams: {
          source: 'recruitment_status',
        },
        flex: '1'
      },
      {
        headerName: 'Location Name',
        field: 'name',
        cellRenderer: 'overrideField',
        cellRendererParams: {
          source: 'name',
        },
        flex: '1'
      },
      {
        headerName: 'Full Address',
        field: 'address',
        valueGetter: (params) => params.data.address || params.data.ctg_address,
        cellRenderer: 'overrideField',
        cellRendererParams: {
          source: 'address',
        },
        flex: '1'
      },
      {
        headerName: 'Country',
        field: 'country',
        cellRenderer: 'overrideField',
        cellRendererParams: {
          source: 'country',
        },
        flex: '1'
      },
      // {
      //   headerName: 'Contact Email',
      //   field: 'contact_email',
      //   cellRenderer: 'overrideField',
      //   cellRendererParams: {
      //     source: 'contact_email',
      //   },
      //   flex: '1'
      // },
      // {
      //   headerName: 'Contact Name',
      //   field: 'contact_name',
      //   cellRenderer: 'overrideField',
      //   cellRendererParams: {
      //     source: 'contact_name',
      //   },
      //   flex: '1'
      // },
      // {
      //   headerName: 'Contact Phone',
      //   field: 'contact_phone',
      //   cellRenderer: 'overrideField',
      //   cellRendererParams: {
      //     source: 'contact_phone',
      //   },
      //   flex: '1'
      // },
      // {
      //   headerName: 'Contact Phone Extension',
      //   field: 'contact_phone_ext',
      //   cellRenderer: 'overrideField',
      //   cellRendererParams: {
      //     source: 'contact_phone_ext',
      //   },
      //   flex: '1'
      // },
      // {
      //   headerName: "",
      //   width: 40,
      //   cellRenderer: "removeRow",
      // }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 == 0;
        },
      },
    },
    excelStyles,
    frameworkComponents: {
      // studyLink: StudyLinkForeignKey,
      overrideField: OverrideField,
      // removeRow: ({ data }) => {
      //   const id = data?.id;
      //   return (
      //     <i
      //       className="fal fa-trash-alt"
      //       style={{ color: "red" }}
      //       onClick={() => deleteRow(id)}
      //     ></i>
      //   );
      // },
      LoadRowsComponent: LoadRowsComponent,
    },
    loadingCellRenderer: 'LoadRowsComponent',
    loadingCellRendererParams :{
      loadingMessage: 'One moment please...',
    },
  };

  return (
    <Container className="ag-theme-balham">
      { isStudyDetail
      &&
      <AgGridReact
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        onFilterChanged={onFilterChanged}
        // onCellClicked={event => cellClicked(event)}
        rowData={locationsList}
      ></AgGridReact>
      }
      <TotalRow count={totalRows} />
    </Container>
  );
};

export default LocationsGridReadOnly;

const Container = styled.div`
flex: 1 1 auto;
padding-bottom: 20px;
`
